import Vue from 'vue'
import VueRouter from "vue-router";
import { sync } from 'vuex-router-sync'

import store from './store'
import router from '@/router'
import './load_antd.js'
import App from './App.vue'
import 'ant-design-vue/dist/antd.less'
import '@/assets/css/base.css'

import {checkPermission, isAuthenticated, loginWithToken} from '@/utils/perm'
// import "@/mock"
import { check_rule, fileUrl } from "@/utils/common"

Vue.config.productionTip = true
Vue.use(VueRouter)
sync(store, router)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.prototype.check_rule = check_rule
Vue.prototype.fileUrl = fileUrl
Vue.prototype.setContainer = () => { return triggerNode.parentNode || document.body;}

/*
* 注意：如果调用的next,请确保立刻 return ,不再执行后面的逻辑,否则会出现意想不到的结果！
* */
router.beforeEach((to, from, next) => {
  let query = to.query
  // 处理传承和智能云对接的情况
  if(query.appId && query.clientId && query.insCode) {
    next()
    return
  }

  if(!isAuthenticated(to)) {
    next({
      name: 'login'
    })
    return
  } else {
    /*对于重定向的界面，不做权限检查*/
    if(to.redirect) {
      next()
      return
    }
    /*已经登录，又跳入首页的情况*/
    if(loginWithToken(to)) {
      next('/')
      return
    }

    /* 无权限的界面，跳转到禁止界面*/
    if(to?.meta?.requireAuth && !checkPermission(to.meta.permission)){
      next({
        name: 'forbidden'
      })
      return
    }

    let router = to
    let menu = router.meta.menu || []
    let subMenu = router.meta.subMenu || []
    store.commit('SET_MENU_SUBMENU', {menu: [menu], subMenu: [subMenu]})

    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
